import { useTranslation } from "react-i18next";
import React from "react";
import Messenger from "./Messenger";
import { scrollIntoView } from "../Helpers/scrollTo";

export type Interaction = {
    conversation: {
        sender: 'sender' | 'recipient';
        text: string;
    }[];
}

export const LiveCam = () => {
    const { t } = useTranslation();
    const videoRef = React.useRef<HTMLVideoElement>(null);
    const [endedVideo, setEndedVideo] = React.useState<boolean>(false);
    const conversation: Interaction['conversation'] = [
     {sender: 'recipient', text:t("Hey Evelyn, du siehst richtig gut aus!")},
     {sender: 'sender', text:t("Dankeschön  Wie geht’s dir so Süßer?")},
     {sender: 'recipient', text:t("Ja mir auch! Magst du mal aufstehen und dich zeigen?")},
     {sender: 'sender', text: t("Klar"),},
     {sender: 'sender', text: t("Gefalle ich dir?")},
     {sender: 'recipient', text: t("Ja du bist mega heiß!")},
     {sender: 'sender', text: t("Hast du vielleicht auch eine Cam?") }
    ];

    React.useEffect(() => {
        let interval: NodeJS.Timeout;
        if (videoRef.current) {
            interval = setInterval(() => {
                if (!videoRef.current) return;
                if (Math.floor(videoRef.current!.currentTime)) dispatchEvent(new CustomEvent('videoProgress'));
                if(Math.floor(videoRef.current!.currentTime) >= Math.floor(videoRef.current!.duration)) {
                    videoRef.current!.style.filter = 'blur(40px)';
                    videoRef.current!.volume = 0;
                    setEndedVideo(true);
                    clearInterval(interval);
                }
            }, 1000);
        }
        return () => interval && clearInterval(interval);
    }, []);
    
    return (
        <div className="box">
           <h2>{t('Live-Cam Beispiel mit Evelyn Blond')}</h2>
           <p>{t('So könnte deine Live-Cam Session aussehen')}</p>
           <div  className="video-preview-livecam">
                <video ref={videoRef} autoPlay loop playsInline muted preload="auto">
                    <source src="video/evelyn.mp4" type="video/mp4" />
                </video>
                <div className="rec-container">
                    <div className="rec-circle"></div>
                    <p className="reset-margin">REC</p>
                </div>
                <div className="eg-label">
                    {endedVideo ? (
                        <small>{t('Beispiel-Mitschnitt vorbei')}</small>
                        ) : (
                        <small>{t('Beispiel-Mitschnitt')}</small>
                    )}
                </div>
           </div>
           <Messenger conversation={conversation} timing={{recipient: [1,18,52], sender: [10,21,46,64]}} />
           <button className="btn std-height flex-align-center gap-1-half livecams-background" onClick={() => scrollIntoView('form_container')}>
                {t('Jetzt los chatten')} <span className="icon--ri live-line font-size-1"></span>
            </button>
        </div>
    )
}
